export default "__VITE_ASSET__D9PvBvdP__"